/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Upload a given file to the server and handle the mapping payload
 *
 * @param  {Function} options.commit
 * @param  {File} data
 * @return {Void}
 */
const uploadFile = ({ commit }, data) => {
    const uploadUrl = 'projects/opex-importer/'
    let formData = new FormData()
    formData.append('file', data.file)
    if (data.excel_sheet !== null) {
        formData.append('excel_sheet', data.excel_sheet)
    }

    commit('BEGIN_UPLOAD')

    http.post(uploadUrl, formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            let val = (progressEvent.loaded * 100) / progressEvent.total
            let progress = Math.round(val)
            commit('UPDATE_UPLOAD_PROGRESS', progress)
        }
    })
    .then(res => {
        let payload = res.data
        payload.category_list.push('Excluded Items')
        payload.category_list = payload.category_list.filter(item => item !== null)
        commit('SET_DATA', payload)
        commit('projects/form/UPDATE_FILE_ID', {
            id: payload.meta.opex_file_id,
            type: 'opex_file_id'
        }, { root: true })
        return res
    })
    .catch(err => commit('SET_DATA_ERROR', err.response.data))
}

/**
 * Show the modal
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const showOpexModal = ({ commit }) => {
    commit('SHOW_MODAL')
}

/**
 * Hide the modal
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const hideOpexModal = ({ commit }) => {
    commit('HIDE_MODAL')
}

/**
 * Update the selected category
 *
 * @param  {Function} options.commit
 * @param  {String} category
 * @return {Void}
 */
const updateSelectedCategory = ({ commit }, payload) => {
    commit('UPDATE_SELECTED_CATEGORY', payload)
}

/**
 * Update an item's category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateItemCategory = ({ commit }, payload) => {
    commit('UPDATE_ITEM_CATEGORY', payload)
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Update the given search term
 *
 * @param  {Function} options.commit
 * @param  {String} payload
 * @return {Promise}
 */
const updateSearchTerm = ({ commit }, payload) => commit('UPDATE_SEARCH_TERM', payload)

/**
 * Import the reviewed OPEX line items
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const importItems = ({ commit, state, dispatch }) => {
    let url = `projects/opex-update/${state.meta.opex_file_id}/`
    commit('IMPORT_BEGIN')
    setTimeout(() => {
        http
            .patch(url, {
                miscinc: state.miscinc,
                mappings: state.mappings
            })
            .then(res => {
                dispatch('projects/form/ingestOpexValues', res.data, {
                    root: true
                })
                .then(() => commit('IMPORT_SUCCESS'))
            })
            .catch(err => console.log(err))
    }, 2000)
}

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const requestFileAssistance = ({ commit, state }) => {
    commit('REQUEST_FILE_ASSISTANCE')
    http.post(`projects/import-file/${state.error.opex_file_id}/support/`)
        .then(res => commit('SUPPORT_REQUEST_SUCCESS', res))
        .catch(err => commit('SUPPORT_REQUEST_FAILURE', err))
}

export default {
    resetState,
    uploadFile,
    importItems,
    showOpexModal,
    hideOpexModal,
    updateSearchTerm,
    updateItemCategory,
    requestFileAssistance,
    updateSelectedCategory
}



// WEBPACK FOOTER //
// ./src/state/modules/opex-importer/actions.js